<template>
  <div class="page-content"  id="monitoringStore">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/newStore' }">监控店铺</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form label-width="130px">
        <div style="margin: 0 20px 20px 40px;">
          <el-tag type="warning" style="width: 100%;">
            <img src="../../../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
            <span>当前监控模式为：
              <span v-if="retrieve === '0'">标价</span>
              <span v-if="retrieve === '1'">到手价</span>
              <span v-if="retrieve === '2'">标价&到手价</span>
            </span>
          </el-tag>
        </div>
        <el-form-item label="监控时间：" :required="true">
          <el-select
            size="small"
            v-model="plathour"
            multiple
            placeholder="请选择"
            style="width: 425px;"
            :multiple-limit="limitMonitorTimeNum"
          >
            <el-option
              v-for="item in time"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <span style="padding-left: 15px;color: #FAAD14;">
            可设置{{limitMonitorTimeNum}}个监控时间
          </span>
        </el-form-item>

        <el-form-item label="监控店铺：" :required="true">
          <div class="addFont" @click="newAdd">
            <i class="el-icon-plus"></i>
            新增监控店铺
          </div>
        </el-form-item>
      </el-form>

      <el-button size="small" style="margin-left: 47px;margin-bottom: 8px;" @click="delSure('批量删除')">
        批量删除
      </el-button>
      <span style="padding-left: 15px;color: #FAAD14;">
        可监控店铺数量上限：{{chiLdNum}}/{{allLimitProNum}}
      </span>
      <el-table
        @selection-change="handleSelectionChange"
        :data="productsData"
        ref="multipleTable"
        style="padding-left: 47px;padding-bottom: 10px;"
        height="400"
        >
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="平台" prop="platformchild">
          <template slot-scope="scope">
            {{ scope.row.platformchild | platformChinese }}
          </template>
        </el-table-column>
        <el-table-column label="店铺" prop="shopnamechild">
        </el-table-column>
        <el-table-column width="210" label="操作">
          <template slot-scope="scope">
            <div class="g-margin-left" style="color: #108cee;cursor: pointer;">
              <i class="el-icon-delete"></i>
              <span class="g-inline-block" @click="delSure(scope.$index)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <shopLink ref="childShopLink" @fromChild="getChild"></shopLink>
      <el-form label-width="130px" style="margin-top: 24px;">
        <el-form-item label="通知人：">
          <el-select v-model="openid" multiple placeholder="请选择" size="small" style="width: 425px;">
            <el-option
              v-for="item in WecharList"
              :key="item.openid"
              :label="item.nickname"
              :value="item.openid">
            </el-option>
          </el-select>
          <el-button type="text" size="small" style="margin-left: 8px;" @click="getbmcwx">新增通知人</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-left: 51px;margin-top: 40px;">
        <el-button size="small" class="g-confirm-btn" @click="save" type="primary" :loading="saveLoading">确 认</el-button>
  			<el-button size="small" class="g-cancel-btn" @click="$router.push(`/newStore`)" type="TheCustom">取 消</el-button>
      </div>
    </section>
  </div>
  <wxBindingComponent ref="childWxBinding"/>
</div>

</template>

<script>
  import shopLink from "./shopLink.vue";
  import wxBindingComponent from "../../../../components/wxComponent/wxBindingComponent.vue";
  import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        retrieve: '',
        storeAlinkShow: false,
        storePlatform: '',
        status: 0,
        title: '新增',
        bid: '',
        wechatUrl: '',
        saveLoading: false,
        multipleSelection:[],
        time:[],
        openid: [],
        planname: '',
        plathour: [],
        platform: [],
        limitMonitorTimeNum: 1,
        allLimitProNum: 0,
        productsData: [],
        WecharList: [],
        faData: [],
        shopmonitorPlatform: [],
        chiLdNum: 0,
        totalNum: 0,
      }
    },
    mounted() {
      // 获取监控时间监控个数
      fetch({
  			url: 'hcm/cus/selectbmcSetting'
  		}).then(res => {
  			if(res.status === '10000') {
  				this.limitMonitorTimeNum = res.data.shopmonitorFrequency === 1 ? 2 : 1;
          this.allLimitProNum = res.data.shopmonitorNumber;
          this.retrieve = res.data.retrieve;
          if (res.data.shopmonitorPlatform) {
            let platArr = []
            platArr = res.data.shopmonitorPlatform.split(',')
            console.log('可监控平台',platArr)
            for (let a in platArr) {
              if (platArr[a] == 'TB') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '淘宝'
                })
              } else if (platArr[a] == 'TM') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '天猫'
                })
              } else if (platArr[a] == 'JD') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '京东'
                })
              } else if (platArr[a] == 'SN') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '苏宁'
                })
              } else if (platArr[a] == 'PDD') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '拼多多'
                })
              } else if (platArr[a] == '1688') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '1688'
                })
              } else if (platArr[a] == 'DD') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '当当'
                })
              }
            }
          }
  			}
  		})
      this.totalNum = Number(this.$route.query.totalNum)
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum
      // 获取监控时间
      this.generateMonitorTime();
      this.getWecharList();
    },
    methods: {
      // 获取bid调用微信接口
      getbmcwx() {
        fetch({
          url: "hcm/userout/getbmcwx",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.bid = data.data.bid
            this.addWechatPerson()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      addWechatPerson() {
  			this.$refs.childWxBinding.getbmcwx('m',this.bid)
  		},
      // 生成0 - 24点的时间
      generateMonitorTime() {
  			let res = [];
  			for(let i = 0; i <= 23;i++) {
          if (i <= 9) {
            res.push(`0${i}:00`)
          } else {
            res.push(`${i}:00`)
          }
  			}
  			this.time = res;
  		},
      // 新增监控产品
      newAdd() {
        let data = {
          allLimitProNum: this.allLimitProNum,
          shopmonitorPlatform: this.shopmonitorPlatform,
          totalNum: this.chiLdNum
        }
        this.$refs.childShopLink.faOpen(data)
      },
      // 获取微信通知人数据
      getWecharList() {
        fetch({
          url: "hcm/hcmNewMonitorProduct/getWecharList",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.WecharList = res.data
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 子传父
      getChild(data) {
        // 新增监控产品表格数据
        if (this.productsData.length != 0) {
          for (let c in data) {
            for (let aa in this.productsData) {
              if (this.productsData[aa].platformchild == data[c].platformchild && this.productsData[aa].shopnamechild == data[c].shopnamechild) {
                this.$message({
                  message: '存在重复监控的店铺，系统已自动删除',
                  type: 'warning'
                });
                data.splice(c,1)
              }
            }
          }
        }
        for (let z in data) {
          this.productsData.push({
            platformchild: data[z].platformchild,
            shopnamechild: data[z].shopnamechild,
          })
        }
        this.chiLdNum = 0
        this.chiLdNum = this.totalNum + this.productsData.length
        if (this.chiLdNum > this.allLimitProNum) {
          this.$message({
            message: '超过监控链接数量上限',
            type: 'warning'
          });
        }
      },
      delSure(index) {
        if (index == '批量删除') {
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择产品信息',
              type: "error"
            });
            return;
          }
          for (let a in this.multipleSelection) {
            for (let b in this.productsData) {
              if (this.multipleSelection[a] === this.productsData[b]) {
                this.productsData.splice(b,1)
              }
            }
          }
        } else {
          this.productsData.splice(index,1)
        }
        this.chiLdNum = 0
        this.chiLdNum = this.totalNum + this.productsData.length
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      save() {

        if (this.chiLdNum > this.allLimitProNum) {
          this.$message({
            message: '超过监控链接数量上限',
            type: 'warning'
          });
          return
        }
        if (this.plathour.length == 0) {
          this.$message({
            message: '请选择监控时间',
            type: 'warning'
          });
          return
        }
        if (this.productsData.length == 0) {
          this.$message({
            message: '请添加监控店铺',
            type: 'warning'
          });
          return
        }
        this.saveLoading = true
        let allData = []
        console.log(this.productsData)
        for (let b in this.productsData) {
          allData.push({
            noticeuserid: this.openid.join(','),
            plathour: this.plathour.join(','),
            platform: this.productsData[b].platformchild,
            shopname: this.productsData[b].shopnamechild,
            status: 1,
            pushmode: this.$route.query.pushmode
          })
        }
        console.log(allData)
        let params = allData
        if (this.$route.query.id) {
          params.id = this.$route.query.id
          params.status = this.status
        }
        fetch({
          method: 'POST',
  				url: 'hcm/hcmShopMonitor/insertByList',
  				data: JSON.stringify(params),
  				headers: {
  					'Content-Type': 'application/json'
  				}
        }).then(res => {
          if(res.status == '10000'){
            this.saveLoading = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            // 新增的话数据清空
            if (!this.$route.query.id) {
              this.planname = ''
              this.platform = []
              this.plathour = []
              this.productsData = []
              this.openid= []
            }
            this.$router.push(`/newStore`)
          } else {
            this.$message.error(res.message);
          }
        })
      },
    },
    components: {
      shopLink,
      wxBindingComponent
    }
  }
</script>
<style lang="scss">
  #monitoringStore{
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .addFont {
      color: #108cee;
      font-weight: bold;
      text-align: center;
      border: 1px dashed #e8ebec;
      height: 30px;
      width: 425px;
      line-height: 30px;
      cursor: pointer;
    }
    .addFont:hover {
      border: 1px dashed #108cee;
    }
  }
</style>
